import { TradingSystem } from '../trading-system';

export enum DashboardLayouts {
  TTPDashboard = 'ttp-dashboard',
  TTPDashboardNew = 'ttp-dashboard-new',
  FiversDashboard = '5ers-dashboard',
  FiversDashboardNew = '5ers-dashboard-new',
  FiversContestDashboard = '5ers-contest-dashboard',
  TTPContestDashboard = 'ttp-contest-dashboard',
}

export const dashboardLayoutsByTradingSystem: Partial<
  Record<TradingSystem, DashboardLayouts>
> = {
  [TradingSystem.MetaTraderContest]: DashboardLayouts.FiversContestDashboard,
};
